import React, { useContext, useEffect, useState } from 'react'
import {
  Accordion,
  BodyText,
  AccordionRow,
  HeadingText,
  ArrowLeftIcon,
  IconButton,
  SearchInput,
} from '@paypalcorp/pp-react'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import PropTypes from 'prop-types'

const HelpSheet = (props) => {
  const { userDetails } = props
  const worldReady = useContext(WorldReadyContext)
  const genericName = new MessageFormat(worldReady, {
    id: `thirdPartyPerm.genericThirdParty`,
  }).format()
  const [searchText, setSearchText] = useState('')
  const [searchRes, setSearchRes] = useState([...props.permissions])
  const [permissions, setPermissions] = useState([])

  // add screen text and isOpen fields to the set of permissions for searching and closing functionalities
  useEffect(() => {
    props.setSuccessMsg('')
    const modPerms = [...props.permissions]
    for (let i = 0; i < modPerms.length; i++) {
      modPerms[i].screenText = new MessageFormat(worldReady, {
        id: `thirdPartyPerm.${modPerms[i].text_ref}`,
      }).format()
      modPerms[i].isOpen = false
    }
    setPermissions([...modPerms])
  }, [props, worldReady])

  // change the state of the permission on accordion click
  const onAccordionClick = (id, state) => {
    let newSearchRes = [...searchRes]
    newSearchRes = newSearchRes.map((p) => {
      if (p.id === id) {
        p.isOpen = state
      } else {
        p.isOpen = false
      }
      return p
    })
    setSearchRes([...newSearchRes])
  }

  // method to implement search functionality
  const searchEntry = (st) => {
    setSearchText(st)
    let searchPermissions = [...permissions]
    searchPermissions.forEach((p) => {
      p.isOpen = false
    })
    if (st !== '') {
      searchPermissions = searchPermissions.filter((p) =>
        p.screenText.toLowerCase().includes(st.toLowerCase()),
      )
    }
    setSearchRes([...searchPermissions])
  }

  // to render all the permissions in the search results
  const renderPermissions = () => {
    return searchRes.map((permission, index) => {
      return (
        <AccordionRow
          heading={<Message id={`thirdPartyPerm.${permission.text_ref}`} />}
          key={index}
          id={`help_${permission.name}`}
          isOpen={permission.isOpen}
          onClick={(_evt, _row, state) =>
            onAccordionClick(permission.id, state)
          }
          className="accordionRow"
        >
          <BodyText className="accordionPadding">
            <Message
              id={`thirdPartyPerm.${permission.help_ref}`}
              merchant_name={genericName}
              uList={(innerMessage) => <ul>{innerMessage}</ul>}
              lList={(innerMessage) => <li>{innerMessage}</li>}
              email={userDetails.email}
              DOB={userDetails.DOB}
              address={userDetails.address}
              phone={userDetails.phone}
              zip={userDetails.zip}
              city={userDetails.city}
              firstName={userDetails.firstName}
              lastName={userDetails.lastName}
              country={userDetails.country}
              userFullNameExtended={userDetails.userFullNameExtended}
              businessName={userDetails.businessName}
              payerID={userDetails.payerID}
              state={userDetails.state}
            />
          </BodyText>
        </AccordionRow>
      )
    })
  }

  return (
    <div
      className={props.windowWidth <= props.mobileScreenSize ? 'tpp_root' : ''}
    >
      <IconButton
        onClick={() => props.setHelpOpen({ type: 'help', value: false })}
        size="sm"
        buttonType="tertiary"
        svgIconComponent={ArrowLeftIcon}
      />
      {/* <HeadingText className="tppView_Heading view_heading">
       */}
      <HeadingText
        className="tppView_Heading viewHeading_marginBottom"
        size="lg"
      >
        <Message id="thirdPartyPerm.helpPageHeading" />
      </HeadingText>
      <SearchInput
        onChange={(event) => searchEntry(event.target.value)}
        onClear={() => searchEntry('')}
        value={searchText}
        id="helpPageSearch"
      />
      <Accordion headerSize="small" className="view_subHeadingUpper">
        {renderPermissions()}
      </Accordion>
    </div>
  )
}

HelpSheet.propTypes = {
  userDetails: PropTypes.object,
  permissions: PropTypes.array,
  setHelpOpen: PropTypes.func,
  windowWidth: PropTypes.any,
  mobileScreenSize: PropTypes.any,
  setSuccessMsg: PropTypes.func,
}

export default HelpSheet
